"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _reactLoadScript = _interopRequireDefault(require("react-load-script")),
    _lodash = _interopRequireDefault(require("lodash.debounce")),
    _reactPlacesAutocomplete = require("react-places-autocomplete"),
    _ManualLocationForm = _interopRequireDefault(require("./ManualLocationForm")),
    _LabelWrapper = _interopRequireDefault(require("../../LabelWrapper")),
    _Link = _interopRequireDefault(require("../../Link")),
    _address = require("../utils/address"),
    _locationSelector = require("../styles/locationSelector"),
    _LocationSelector = _interopRequireDefault(require("./LocationSelector")),
    _isEmptyAddress = _interopRequireDefault(require("../utils/isEmptyAddress"));

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

function focusInput(a) {
  var b = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : {},
      c = b.childInput,
      d = c ? document.querySelector("#".concat(a, " input")) : document.getElementById(a);
  d && (d.blur(), d.focus());
}

var LocationSelectorRoot = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.onScriptLoaded = function () {
      d.setState({
        apiReady: !0
      });
    }, d.onSelectGoogleAddress = function () {
      var a = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a(b) {
        var c, e;
        return _regenerator["default"].wrap(function (a) {
          for (;;) {
            switch (a.prev = a.next) {
              case 0:
                if (b) {
                  a.next = 2;
                  break;
                }

                return a.abrupt("return");

              case 2:
                return a.prev = 2, d.setState({
                  loading: !0
                }), a.next = 6, (0, _reactPlacesAutocomplete.geocodeByAddress)(b);

              case 6:
                c = a.sent, e = c[0].address_components, d.setState({
                  address: (0, _address.buildAddressStateFromRes)(e),
                  isManualEntry: !0,
                  addressRepresentation: "",
                  loading: !1
                }, function () {
                  var a = d.state.address;
                  d.debouncedOnSelectAddress((0, _address.getFullAddressFromPartial)(a), {
                    isValidAddress: (0, _address.isValidAddress)(a)
                  }), focusInput("street-address");
                }), a.next = 14;
                break;

              case 11:
                a.prev = 11, a.t0 = a["catch"](2), d.setState({
                  loading: !1
                });

              case 14:
              case "end":
                return a.stop();
            }
          }
        }, a, null, [[2, 11]]);
      }));
      return function () {
        return a.apply(this, arguments);
      };
    }(), d.requestUserLocation = function () {
      var a = d.state.userLocation;
      a || navigator.geolocation.getCurrentPosition(d.setUserLocation);
    }, d.setUserLocation = function (a) {
      a && d.setState({
        userLocation: a
      });
    }, d.handleAddressInputChange = function (a) {
      d.setState({
        addressRepresentation: a
      });
    }, d.handleToggleForm = function () {
      var a = d.props.id;
      d.setState(function (a) {
        var b = a.isManualEntry;
        return {
          isManualEntry: !b,
          addressRepresentation: "",
          address: {}
        };
      }, function () {
        var b = d.state.isManualEntry;
        d.debouncedOnSelectAddress((0, _address.getFullAddressFromPartial)({}), {
          isValidAddress: !1
        }), focusInput(b ? "street-address" : a, {
          childInput: !b
        });
      });
    }, d.handleManualAddressChange = function (a) {
      return function (b) {
        var c = b.target.value,
            e = d.state.address,
            f = _objectSpread(_objectSpread({}, e), {}, (0, _defineProperty2["default"])({}, a, c));

        d.setState({
          address: f
        }, function () {
          d.debouncedOnSelectAddress((0, _address.getFullAddressFromPartial)(f), {
            isValidAddress: (0, _address.isValidAddress)(f)
          });
        });
      };
    }, d.state = {
      addressRepresentation: "",
      address: a.initialAddress || {},
      apiReady: !1,
      isManualEntry: !(0, _isEmptyAddress["default"])(a.initialAddress)
    }, d.debouncedOnSelectAddress = (0, _lodash["default"])(a.onSelectAddress, 100), d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "render",
    value: function render() {
      var a = this.state,
          b = a.apiReady,
          c = a.addressRepresentation,
          d = a.userLocation,
          e = a.isManualEntry,
          f = a.address,
          g = this.props,
          h = g.placeholder,
          i = g.label,
          j = g.id,
          k = g.disabled,
          l = g.labelProps,
          m = g.dropdownType;
      return _react["default"].createElement("div", {
        className: _locationSelector.LOCATION_SELECTOR__ROOT
      }, _react["default"].createElement(_reactLoadScript["default"], {
        url: "https://maps.googleapis.com/maps/api/js?key=AIzaSyDsF3S_T5qytLOSEvdxGGYk6lLvAHH6hXY&libraries=places",
        onLoad: this.onScriptLoaded
      }), _react["default"].createElement(_LabelWrapper["default"], (0, _extends2["default"])({}, l, {
        id: j,
        label: i,
        extraLabelContent: k ? null : _react["default"].createElement(_Link["default"], {
          button: !0,
          className: _locationSelector.MANUAL_LOCATION_LINK,
          onClick: this.handleToggleForm
        }, e ? "Search For Your Address" : "Enter Address Manually")
      }), b ? _react["default"].createElement(_LocationSelector["default"], {
        id: j,
        addressString: c,
        onChangeAddress: this.handleAddressInputChange,
        onSelect: this.onSelectGoogleAddress,
        userLocation: d,
        placeholder: h,
        disabled: k,
        isManualEntry: e,
        requestUserLocation: this.requestUserLocation,
        dropdownType: m
      }) : null), e ? _react["default"].createElement(_ManualLocationForm["default"], {
        address: f,
        onChangeAddressField: this.handleManualAddressChange,
        disabled: k
      }) : null);
    }
  }]), b;
}(_react.Component);

exports["default"] = LocationSelectorRoot, LocationSelectorRoot.defaultProps = {
  placeholder: "Enter location"
};